<template>
  <el-image class="bg-transparent"
    :src="`https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=${id}&size=130`"
  />
</template>

<script>
export default {
  name: "ChatSticker", props: ["id"]
};
</script>

<style scoped>

</style>